export enum SubscriptionPlans {
    PoBoxAddresses,
    StreetAddresses,
    BusinessAddresses,
    ParcelAddress,
    RedirectionAddresses,
}